import React from 'react';

type AccordionContextType = {
    activeEventKey?: number | string | null;
    onToggle?: (dispatchedEventKey: any) => void;
} | null;

export default React.createContext<AccordionContextType>(null);
